<template>
  <view-toolbox
    back-title="Form Menu"
    title="Form Action"
  >
    <p v-html="source" />
  </view-toolbox>
</template>

<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import ViewUtils from '@/components/views/ViewUtils';

export default {
  name: 'FormSource',
  components: {
    ViewToolbox,
  },
  mixins: [
    ViewUtils,
  ],
  computed: {
    source() {
      let source = `This form ${this.action} a ${(this.viewRaw.action === 'create') ? 'new ' : ''}<b>${this.object.get('inflections').singular}</b> record`;

      // two connections
      if (this.viewRaw.source.connection_key) {
        const connectionField = this.$store.getters.getField(this.viewRaw.source.connection_key);
        const connectedObjectKey = (connectionField.objectKey === this.viewRaw.source.object) ? connectionField.get('relationship').object : connectionField.objectKey;

        const connectedObject = this.$store.getters.getObject(connectedObjectKey);

        if (connectedObject) {
          const connector = (this.viewRaw.source.authenticated_user) ? 'the logged-in' : 'this page\'s';

          if (this.viewRaw.source.parent_source) {
            const grandparentObject = this.$store.getters.getObject(this.viewRaw.source.parent_source.object);

            if (grandparentObject) {
              source += ` connected to the ${connectedObject.inflections.singular} record connected to ${connector} <b>${grandparentObject.inflections.singular}</b>`;
            } else {
              source += ` connected to <b>${connectedObject.inflections.singular}</b>`;
            }
          } else {
            source += ` connected to ${connector} <b>${connectedObject.inflections.singular}</b>`;
          }
        }
      }

      return `${source}.`;
    },
    action() {
      return (this.viewRaw.action === 'update') ? 'updates' : 'inserts';
    },
  },
};
</script>
